import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
// FORM-ONLY MODE (2026-07-01): the app is now just the quote form. The landing page and the whole
// admin dashboard are UNROUTED (see <Routes> below) so nothing but the form is reachable.
// Nothing is deleted — the page files still exist. To bring any of them back, uncomment its import
// here AND its <Route> below.
// import LandingPage from "@/pages/LandingPage";
import QuoteBuilder from "@/pages/QuoteBuilder";
// import AdminLogin from "@/pages/AdminLogin";
// import AdminDashboard from "@/pages/AdminDashboard";
import { FranchiseProvider } from "@/context/FranchiseContext";

// Wrapper component to provide franchise context
function FranchiseRoute({ children }) {
  return <FranchiseProvider>{children}</FranchiseProvider>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* FORM-ONLY: root and /quote both render the quote form (landing page unrouted). */}
          <Route path="/" element={<FranchiseRoute><QuoteBuilder /></FranchiseRoute>} />
          <Route path="/quote" element={<FranchiseRoute><QuoteBuilder /></FranchiseRoute>} />
          <Route path="/:franchiseSlug" element={<FranchiseRoute><QuoteBuilder /></FranchiseRoute>} />
          <Route path="/:franchiseSlug/quote" element={<FranchiseRoute><QuoteBuilder /></FranchiseRoute>} />

          {/* Admin UNROUTED (form-only). To restore the admin dashboard, uncomment these + the
              imports above — the AdminLogin/AdminDashboard files are untouched.
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          */}

          {/* Catch-all: any other path (incl. old /admin links) just shows the form. */}
          <Route path="*" element={<FranchiseRoute><QuoteBuilder /></FranchiseRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
